import React from 'react';
import { Link } from 'react-router-dom';
import { resolveLink } from '@/lib/siteContent';

/**
 * Admin `promo_banner` / `offers_band` section for the website home.
 * config: { title?, subtitle?, backgroundColor?, textColor?, cta?: { label, link } }
 */
export default function PromoBand({ section }) {
  const c = section.config || {};
  const title = section.title || c.title;
  const subtitle = section.subtitle || c.subtitle;
  const target = c.cta?.link ? resolveLink(c.cta.link) : section.type === 'offers_band' ? { to: '/offers' } : null;
  const label = c.cta?.label || (section.type === 'offers_band' ? 'See offers' : null);
  if (!title && !subtitle) return null;
  return (
    <section className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
      <div
        className="flex flex-col gap-4 rounded-3xl px-6 py-8 sm:flex-row sm:items-center sm:justify-between sm:px-10"
        style={{ background: c.backgroundColor || 'var(--color-brand-tint, #e8f2ff)', color: c.textColor || undefined }}
      >
        <div>
          {title && <h2 className="text-2xl font-bold">{title}</h2>}
          {subtitle && <p className="mt-1 opacity-80">{subtitle}</p>}
        </div>
        {target && label && (target.to ? (
          <Link to={target.to} className="lk-focus inline-flex shrink-0 items-center justify-center rounded-full bg-ink-900 px-6 py-3 text-sm font-semibold text-white">{label}</Link>
        ) : (
          <a href={target.href} target="_blank" rel="noopener noreferrer" className="lk-focus inline-flex shrink-0 items-center justify-center rounded-full bg-ink-900 px-6 py-3 text-sm font-semibold text-white">{label}</a>
        ))}
      </div>
    </section>
  );
}
